import * as React from "react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { useOktaAuth } from "@okta/okta-react";
import { useEffect } from "react";
import {LoadingSpinner} from "../icons/LoadingSpinner.component";
import { Outlet, useNavigate, NavigateFunction } from "react-router-dom";
import {triggerOktaLogin} from "../../utils/oktaUtil";
import {navigateTo} from "../../../navigateTo";

export const RequiredAuth: React.FunctionComponent = () => {
    const { oktaAuth, authState } = useOktaAuth();

    useEffect(() => {
        if (!authState) {
            return;
        }

        if (!authState?.isAuthenticated) {
            const originalUri = toRelativeUrl(window.location.href, window.location.origin);
            triggerOktaLogin(originalUri);
        }
    }, [oktaAuth, !!authState, authState?.isAuthenticated]);

    if (!authState || !authState?.isAuthenticated) {
        return (<LoadingSpinner/>);
    }

    return (<Outlet/>);
};

export const IRIS_ORIGINAL_URI_KEY = "iris_original_uri";
export const IRIS_WAS_AUTHENTICATED_KEY = "iris_was_authenticated";

export const RequiredAuthWithLanding: React.FunctionComponent = () => {
    const { authState } = useOktaAuth();
    const navigate: NavigateFunction = useNavigate();

    useEffect(() => {
        if (!authState) {
            return;
        }

        if (!authState?.isAuthenticated) {
            const currentPath = window.location.pathname;
            const currentSearch = window.location.search;
            const fullPath = currentPath + currentSearch;
            
            const wasAuthenticated = localStorage.getItem(IRIS_WAS_AUTHENTICATED_KEY) === "true";
            
            if (wasAuthenticated) {
                localStorage.removeItem(IRIS_WAS_AUTHENTICATED_KEY);
                triggerOktaLogin(fullPath);
                return;
            }
            
            if (currentPath !== "/landing" && currentPath !== "/login/callback") {
                localStorage.setItem(IRIS_ORIGINAL_URI_KEY, fullPath);
            }
            navigateTo("/landing", navigate);
        }
    }, [authState, authState?.isAuthenticated, navigate]);

    if (!authState || !authState?.isAuthenticated) {
        return (<LoadingSpinner/>);
    }

    return (<Outlet/>);
};